<div cdkTrapFocus aria-live="assertive" class="rail-eticket-download-modal">
  <div class="modal-header">
    <h3 class="modal-title" id="modal-header" i18n="@@download_print_pdf">
      Download/print eTicket
    </h3>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <p class="instruction-text" i18n="@@rail_eticket_instruction">
      Choose preferred option for each leg of your journey
    </p>

    @for (eTicketItem of eTicketItems; track $index) {
      <div class="eticket-leg-box">
        <div class="eticket-direction">
          <strong>{{ eTicketItem.direction }}</strong>
          @if (eTicketItem.ticketNumber && eTicketItem.ticketNumber !== 'eticket') {
            <span class="ticket-number">{{ eTicketItem.ticketNumber }}</span>
          }
        </div>
        @if (eTicketItem.passengerName) {
          <div class="eticket-label eticket-passenger">{{ eTicketItem.passengerName }}</div>
        }
        @if (eTicketItem.fareRoute) {
          <div class="eticket-label">{{ eTicketItem.fareRoute }}</div>
        }
        @if (eTicketItem.fareName) {
          <div class="eticket-label">{{ eTicketItem.fareName }}</div>
        }
        @if (eTicketItem.label) {
          <div class="eticket-label">{{ eTicketItem.label }}</div>
        }

        <div class="eticket-options">
          <!-- PDF Download -->
          @if (eTicketItem.pdfLink) {
            @if (isTrainline) {
              <button
                type="button"
                class="eticket-option"
                [disabled]="downloadingItems.has('pdf-' + eTicketItem.ticketNumber)"
                (click)="downloadETicket(eTicketItem.pdfLink, 'pdf-' + eTicketItem.ticketNumber)"
              >
                <img
                  [src]="walletImageBaseUrl + 'print-eticket.png'"
                  alt="Download/print eTicket"
                  width="24"
                  height="24"
                />
                <span i18n="@@download_print_pdf"> Download/print eTicket </span>
              </button>
            } @else {
              <a [href]="eTicketItem.pdfLink" target="_blank" class="eticket-option">
                <img
                  [src]="walletImageBaseUrl + 'print-eticket.png'"
                  alt="Download/print eTicket"
                  width="24"
                  height="24"
                />
                <span i18n="@@download_print_pdf"> Download/print eTicket </span>
              </a>
            }
          }

          <!-- Apple Wallet -->
          @if (eTicketItem.iosLink) {
            @if (isTrainline) {
              <button
                type="button"
                class="eticket-option"
                [disabled]="downloadingItems.has('ios-' + eTicketItem.ticketNumber)"
                (click)="downloadETicket(eTicketItem.iosLink, 'ios-' + eTicketItem.ticketNumber)"
              >
                <img
                  [src]="walletImageBaseUrl + 'apple-wallet.png'"
                  alt="Add to Apple Wallet"
                  width="120"
                  height="40"
                />
              </button>
            } @else {
              <a [href]="eTicketItem.iosLink" target="_blank" class="eticket-option">
                <img
                  [src]="walletImageBaseUrl + 'apple-wallet.png'"
                  alt="Add to Apple Wallet"
                  width="120"
                  height="40"
                />
              </a>
            }
          }

          <!-- Google Wallet -->
          @if (eTicketItem.androidLink) {
            @if (isTrainline) {
              <button
                type="button"
                class="eticket-option"
                [disabled]="downloadingItems.has('android-' + eTicketItem.ticketNumber)"
                (click)="
                  downloadETicket(eTicketItem.androidLink, 'android-' + eTicketItem.ticketNumber)
                "
              >
                <img
                  [src]="walletImageBaseUrl + 'google-wallet.png'"
                  alt="Add to Google Wallet"
                  width="120"
                  height="40"
                />
              </button>
            } @else {
              <a [href]="eTicketItem.androidLink" target="_blank" class="eticket-option">
                <img
                  [src]="walletImageBaseUrl + 'google-wallet.png'"
                  alt="Add to Google Wallet"
                  width="120"
                  height="40"
                />
              </a>
            }
          }
        </div>
      </div>
    }
    @if (downloadError) {
      <p class="download-error">{{ downloadError }}</p>
    }
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="modal_button_okay"
      (click)="closeModal()"
      i18n="@@modalFlightFareOK"
    >
      Close
    </button>
  </div>
</div>
